/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/jsx-no-useless-fragment */

import React, { useState, useRef } from 'react';
import parse from 'html-react-parser';

import TooltipIkon from './TooltipIkon';
import { PortalWithState } from 'react-portal';
import { motion, AnimatePresence } from 'framer-motion';
import { uid } from '../Servicetjek.utils';
import { ITooltip } from './Tooltip.definition';

const Tooltip = ({ text, isText = null }: ITooltip) => {
	if (!text) {
		return null;
	}
	const [position, setPosition] = useState({ x: undefined, y: undefined });
	const ref = useRef(null);
	const btnRef = useRef(null);

	const handleOpen = (e, open) => {
		window.addEventListener('scroll', handleScroll);
		handlePosition();
		open(e);
	};

	const handlePosition = () => {
		if (btnRef.current) {
			const { x, y } = btnRef.current.getBoundingClientRect();
			/** Positioner tooltip i center af knappen */
			setPosition({ x, y });
		}
	};

	const handleScroll = () => {
		if (ref.current && ref.current.state.active) {
			ref.current.closePortal();
			window.removeEventListener('scroll', handleScroll);
		}
	};


	return (
		<PortalWithState ref={ ref } closeOnOutsideClick closeOnEsc>
			{ ({ openPortal, isOpen, portal }) => (
				<>
					<button type="button" ref={ btnRef } onClick={ e => handleOpen(e, openPortal) } className="button button--reset button--tooltip" style={ { padding: '1px' } }>
						{ isText ? (
							<>
								{ parse(isText) }
							</>
						) : (
							<TooltipIkon />
						) }
					</button>

					{ /* @ts-ignore */ }
					<AnimatePresence>
						{ portal(
							<>
								{ isOpen && (
									<motion.div
										className="servicetjek__tooltip__content"
										key={ uid() }
										initial={ { opacity: 0 } }
										exit={ { opacity: 0 } }
										transition={ { ease: 'easeOut' } }
										animate={ {
											opacity: 1
										} }
										style={ {
											transformOrigin: 'top left',
											position: 'fixed',
											top: position.y,
											left: position.x,
											width: '300px',
											background: 'white',
											minHeight: '150px'

										} }
									>
										<div dangerouslySetInnerHTML={ { __html: text } } />
									</motion.div>
								) }
							</>
						) }
					</AnimatePresence>
				</>
			) }
		</PortalWithState>
	);
};

export default Tooltip;
